"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _SkeletonBase = _interopRequireDefault(require("./SkeletonBase"));

var _getSize = require("../operators/getSize");

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  height: 0.75em;\n  left: 0;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 100%;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: relative;\n  width: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var SkeletonTextWrapper = _styledComponents.default.div.withConfig({
  displayName: "SkeletonText__SkeletonTextWrapper",
  componentId: "g6271y-0"
})(_templateObject(), function (_ref) {
  var width = _ref.width;
  return (0, _getSize.getSize)(width);
});

var SkeletonTextInner = (0, _styledComponents.default)(_SkeletonBase.default).withConfig({
  displayName: "SkeletonText__SkeletonTextInner",
  componentId: "g6271y-1"
})(_templateObject2());

var SkeletonText =
/*#__PURE__*/
function (_React$PureComponent) {
  (0, _inherits2.default)(SkeletonText, _React$PureComponent);

  function SkeletonText() {
    (0, _classCallCheck2.default)(this, SkeletonText);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SkeletonText).apply(this, arguments));
  }

  (0, _createClass2.default)(SkeletonText, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          width = _this$props.width,
          rest = (0, _objectWithoutProperties2.default)(_this$props, ["width"]);
      return _react.default.createElement(SkeletonTextWrapper, {
        width: width
      }, "\xA0", _react.default.createElement(SkeletonTextInner, rest));
    }
  }]);
  return SkeletonText;
}(_react.default.PureComponent);

SkeletonText.defaultProps = {
  width: '100%'
};
SkeletonText.propTypes = {
  width: _react.PropTypes.oneOfType([_react.PropTypes.number, _react.PropTypes.string])
};
var _default = SkeletonText;
exports.default = _default;
module.exports = exports.default;